import React from 'react';

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #000;
    --surface: #0a0a0a;
    --surface-2: #111;
    --card: #0f0f0f;
    --border: rgba(255,255,255,0.08);
    --border-h: rgba(255,255,255,0.15);
    --green: #22c55e;
    --green-glow: rgba(34,197,94,0.12);
    --green-sub: rgba(34,197,94,0.08);
    --white: #fff;
    --muted: rgba(255,255,255,0.5);
    --muted2: rgba(255,255,255,0.25);
    --r: 16px; --rsm: 10px; --rlg: 24px;
  }
  html { scroll-behavior: smooth; }
  body { background: var(--bg); color: var(--white); font-family: 'Geist', -apple-system, sans-serif; font-weight: 400; line-height: 1.6; overflow-x: hidden; -webkit-font-smoothing: antialiased; }

  nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; display: flex; align-items: center; justify-content: space-between; padding: 0 2rem; height: 64px; background: rgba(0,0,0,0.85); backdrop-filter: blur(24px); border-bottom: 1px solid var(--border); }
  .nav-logo { display: flex; align-items: center; gap: 8px; text-decoration: none; }
  .logo-mark { width: 30px; height: 30px; background: var(--green); border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 900; color: #000; flex-shrink: 0; }
  .logo-text { font-size: 1rem; font-weight: 800; color: var(--white); letter-spacing: -0.03em; }
  .nav-mid { display: flex; gap: 2px; }
  .nav-a { font-size: 0.875rem; color: var(--muted); text-decoration: none; padding: 0.4rem 0.85rem; border-radius: var(--rsm); transition: all 0.2s; }
  .nav-a:hover { color: var(--white); background: rgba(255,255,255,0.06); }
  .nav-r { display: flex; align-items: center; gap: 0.75rem; }
  .btn-si { font-size: 0.875rem; font-weight: 500; color: var(--muted); background: transparent; border: 1px solid var(--border); padding: 0.45rem 1.1rem; border-radius: var(--rsm); cursor: pointer; text-decoration: none; transition: all 0.2s; }
  .btn-si:hover { color: var(--white); border-color: var(--border-h); }
  .btn-nc { font-size: 0.875rem; font-weight: 700; color: #000; background: var(--green); border: none; padding: 0.5rem 1.2rem; border-radius: var(--rsm); cursor: pointer; text-decoration: none; transition: all 0.2s; }
  .btn-nc:hover { background: #4ade80; transform: translateY(-1px); }

  .hero { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 8rem 1.5rem 5rem; position: relative; overflow: hidden; }
  .hero-glow { position: absolute; top: 30%; left: 50%; transform: translate(-50%, -50%); width: 800px; height: 500px; background: radial-gradient(ellipse, var(--green-glow) 0%, transparent 65%); pointer-events: none; }
  .hero-grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px); background-size: 60px 60px; mask-image: radial-gradient(ellipse 80% 60% at 50% 40%, black 30%, transparent 100%); pointer-events: none; }
  .hero-badge { display: inline-flex; align-items: center; gap: 7px; background: var(--green-sub); border: 1px solid rgba(34,197,94,0.25); border-radius: 100px; padding: 0.35rem 1rem; font-size: 0.78rem; font-weight: 600; color: var(--green); margin-bottom: 2rem; opacity: 0; animation: fu 0.6s ease forwards 0.1s; }
  .bdot { width: 6px; height: 6px; background: var(--green); border-radius: 50%; animation: pulse 2s ease-in-out infinite; }
  .hero-h1 { font-size: clamp(2.8rem, 7vw, 5.75rem); font-weight: 900; line-height: 1.04; letter-spacing: -0.045em; max-width: 900px; margin-bottom: 1.5rem; opacity: 0; animation: fu 0.7s ease forwards 0.2s; }
  .hero-h1 .g { color: var(--green); }
  .hero-p { font-size: clamp(1rem, 2vw, 1.2rem); color: var(--muted); max-width: 520px; line-height: 1.7; margin-bottom: 2.5rem; opacity: 0; animation: fu 0.8s ease forwards 0.35s; }
  .hero-btns { display: flex; gap: 0.75rem; justify-content: center; flex-wrap: wrap; opacity: 0; animation: fu 0.8s ease forwards 0.5s; }
  .btn-p { display: inline-flex; align-items: center; gap: 8px; background: var(--green); color: #000; font-size: 0.95rem; font-weight: 800; padding: 0.85rem 2rem; border-radius: var(--rsm); text-decoration: none; cursor: pointer; transition: all 0.2s; letter-spacing: -0.01em; }
  .btn-p:hover { background: #4ade80; transform: translateY(-2px); box-shadow: 0 8px 32px rgba(34,197,94,0.3); }
  .btn-s { display: inline-flex; align-items: center; gap: 8px; background: rgba(255,255,255,0.05); color: var(--white); font-size: 0.95rem; font-weight: 600; padding: 0.85rem 1.75rem; border-radius: var(--rsm); text-decoration: none; border: 1px solid var(--border); cursor: pointer; transition: all 0.2s; }
  .btn-s:hover { background: rgba(255,255,255,0.09); border-color: var(--border-h); transform: translateY(-1px); }
  .hero-trust { display: flex; align-items: center; gap: 1rem; margin-top: 2.5rem; opacity: 0; animation: fu 0.8s ease forwards 0.65s; }
  .avs { display: flex; }
  .av { width: 28px; height: 28px; border-radius: 50%; border: 2px solid var(--bg); margin-left: -8px; font-size: 11px; font-weight: 700; display: flex; align-items: center; justify-content: center; color: #000; }
  .av:first-child { margin-left: 0; }
  .trust-txt { font-size: 0.8rem; color: var(--muted2); }

  .demo-wrap { margin-top: 4rem; width: 100%; max-width: 800px; opacity: 0; animation: fu 1s ease forwards 0.85s; }
  .demo-card { background: var(--card); border: 1px solid var(--border); border-radius: var(--rlg); overflow: hidden; box-shadow: 0 40px 80px rgba(0,0,0,0.6); }
  .demo-bar { background: var(--surface-2); border-bottom: 1px solid var(--border); padding: 0.875rem 1.25rem; display: flex; align-items: center; gap: 1rem; }
  .demo-dots { display: flex; gap: 6px; }
  .dd { width: 10px; height: 10px; border-radius: 50%; }
  .dd-r { background: #ff5f56; } .dd-y { background: #ffbd2e; } .dd-g { background: #27c93f; }
  .demo-url { flex: 1; background: rgba(255,255,255,0.05); border-radius: 6px; padding: 0.3rem 0.75rem; font-size: 0.75rem; color: var(--muted); text-align: center; }
  .demo-body { padding: 1.5rem; display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
  .ds { background: var(--surface-2); border: 1px solid var(--border); border-radius: var(--rsm); padding: 1rem 1.1rem; }
  .dl { font-size: 0.63rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.12em; color: var(--muted2); margin-bottom: 0.65rem; }
  .di { display: flex; align-items: flex-start; gap: 0.5rem; padding: 0.38rem 0; font-size: 0.78rem; color: rgba(255,255,255,0.72); border-bottom: 1px solid rgba(255,255,255,0.04); line-height: 1.4; }
  .di:last-child { border-bottom: none; }
  .dp { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; }
  .cg { background: #22c55e; } .cy { background: #eab308; } .cr { background: #ef4444; } .cb { background: #3b82f6; }
  .upills { display: flex; gap: 0.5rem; flex-wrap: wrap; margin-top: 0.5rem; }
  .up { font-size: 0.68rem; font-weight: 700; padding: 0.25rem 0.65rem; border-radius: 100px; }
  .uh { background: rgba(239,68,68,.15); color: #f87171; border: 1px solid rgba(239,68,68,.25); }
  .um { background: rgba(234,179,8,.12); color: #facc15; border: 1px solid rgba(234,179,8,.2); }
  .ul { background: rgba(34,197,94,.12); color: #22c55e; border: 1px solid rgba(34,197,94,.2); }

  .logos { padding: 3rem 2rem 4rem; text-align: center; border-top: 1px solid var(--border); }
  .logos-l { font-size: 0.75rem; color: var(--muted2); letter-spacing: 0.08em; margin-bottom: 1.75rem; }
  .logos-r { display: flex; align-items: center; justify-content: center; gap: 3rem; flex-wrap: wrap; }
  .li { font-size: 0.875rem; font-weight: 800; color: rgba(255,255,255,0.18); letter-spacing: 0.04em; text-transform: uppercase; }

  .sw { padding: 6rem 1.5rem; max-width: 1100px; margin: 0 auto; }
  .stag { display: inline-flex; align-items: center; gap: 6px; font-size: 0.72rem; font-weight: 700; color: var(--green); text-transform: uppercase; letter-spacing: 0.12em; margin-bottom: 1rem; }
  .stag::before { content: ''; width: 14px; height: 2px; background: var(--green); border-radius: 2px; }
  .sh2 { font-size: clamp(2rem, 4vw, 3.2rem); font-weight: 900; letter-spacing: -0.045em; line-height: 1.08; margin-bottom: 1rem; }
  .sp { font-size: 1.05rem; color: var(--muted); max-width: 500px; line-height: 1.7; }

  .ps-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem; margin-top: 3rem; }
  .psc { border-radius: var(--r); padding: 2rem; border: 1px solid var(--border); }
  .psc.prob { background: rgba(239,68,68,.04); border-color: rgba(239,68,68,.15); }
  .psc.sol { background: rgba(34,197,94,.04); border-color: rgba(34,197,94,.18); }
  .psh { font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 1.25rem; display: flex; align-items: center; gap: 6px; }
  .psc.prob .psh { color: #f87171; }
  .psc.sol .psh { color: var(--green); }
  .psi { display: flex; align-items: flex-start; gap: 0.75rem; padding: 0.6rem 0; font-size: 0.875rem; line-height: 1.5; border-bottom: 1px solid rgba(255,255,255,0.04); }
  .psi:last-child { border-bottom: none; }
  .psc.prob .psi { color: rgba(255,255,255,.6); }
  .psc.sol .psi { color: rgba(255,255,255,.85); }
  .xi { color: #f87171; font-size: 0.7rem; margin-top: 2px; flex-shrink: 0; }
  .ci { color: var(--green); font-size: 0.7rem; margin-top: 2px; flex-shrink: 0; }

  .stats-bg { background: var(--surface); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); }
  .stats-in { max-width: 1100px; margin: 0 auto; padding: 5rem 1.5rem; display: grid; grid-template-columns: repeat(3,1fr); gap: 1px; background: var(--border); }
  .sb { background: var(--surface); padding: 3rem 2rem; text-align: center; }
  .sn { font-size: 3.5rem; font-weight: 900; letter-spacing: -0.05em; color: var(--green); line-height: 1; margin-bottom: 0.5rem; }
  .sl { font-size: 0.875rem; color: var(--muted); }

  .fbg { background: var(--surface); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); }
  .fg { display: grid; grid-template-columns: repeat(3,1fr); gap: 1rem; margin-top: 3.5rem; }
  .fc { background: var(--card); border: 1px solid var(--border); border-radius: var(--r); padding: 1.75rem; transition: all 0.25s; position: relative; overflow: hidden; }
  .fc::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: linear-gradient(90deg, transparent, var(--green), transparent); opacity: 0; transition: opacity 0.3s; }
  .fc:hover { border-color: var(--border-h); transform: translateY(-3px); box-shadow: 0 16px 40px rgba(0,0,0,0.5); }
  .fc:hover::before { opacity: 1; }
  .fi { width: 40px; height: 40px; background: var(--green-sub); border: 1px solid rgba(34,197,94,.2); border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 1rem; font-size: 18px; }
  .ft { font-size: 0.95rem; font-weight: 700; letter-spacing: -0.02em; margin-bottom: 0.5rem; }
  .fd { font-size: 0.875rem; color: var(--muted); line-height: 1.65; }

  .sgrid { display: grid; grid-template-columns: repeat(5,1fr); gap: 0; margin-top: 3.5rem; position: relative; }
  .sgrid::after { content: ''; position: absolute; top: 20px; left: 12%; right: 12%; height: 1px; background: linear-gradient(90deg, transparent, rgba(34,197,94,.4), transparent); }
  .step { display: flex; flex-direction: column; align-items: center; text-align: center; padding: 0 1rem; }
  .snum { width: 40px; height: 40px; border-radius: 50%; background: var(--surface-2); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; font-size: 0.85rem; font-weight: 800; color: var(--green); margin-bottom: 1rem; position: relative; z-index: 1; flex-shrink: 0; }
  .stitle { font-size: 0.85rem; font-weight: 700; letter-spacing: -0.01em; margin-bottom: 0.4rem; }
  .sdesc { font-size: 0.78rem; color: var(--muted); line-height: 1.55; }

  .tg { display: grid; grid-template-columns: repeat(3,1fr); gap: 1rem; margin-top: 3.5rem; }
  .tc { background: var(--card); border: 1px solid var(--border); border-radius: var(--r); padding: 1.5rem; transition: border-color 0.2s; }
  .tc:hover { border-color: var(--border-h); }
  .tstars { color: var(--green); font-size: 0.8rem; margin-bottom: 0.75rem; letter-spacing: 2px; }
  .ttxt { font-size: 0.875rem; color: rgba(255,255,255,.75); line-height: 1.65; margin-bottom: 1.25rem; }
  .tau { display: flex; align-items: center; gap: 0.6rem; }
  .tav { width: 32px; height: 32px; border-radius: 50%; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; color: #000; flex-shrink: 0; }
  .tnm { font-size: 0.82rem; font-weight: 700; letter-spacing: -0.01em; }
  .trl { font-size: 0.75rem; color: var(--muted2); }

  .pg { display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem; margin-top: 3.5rem; }
  .pc { background: var(--card); border: 1px solid var(--border); border-radius: var(--rlg); padding: 2.25rem; transition: border-color 0.2s; }
  .pc.pop { border-color: var(--green); background: linear-gradient(160deg, rgba(34,197,94,.06) 0%, var(--card) 60%); position: relative; }
  .ptag { position: absolute; top: -1px; right: 2rem; background: var(--green); color: #000; font-size: 0.68rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.08em; padding: 0.3rem 0.9rem; border-radius: 0 0 10px 10px; }
  .pname { font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.12em; color: var(--muted); margin-bottom: 1rem; }
  .pprice { display: flex; align-items: flex-end; gap: 4px; margin-bottom: 0.5rem; }
  .pprice .amt { font-size: 3.25rem; font-weight: 900; letter-spacing: -0.055em; line-height: 1; }
  .pprice .dol { font-size: 1.25rem; font-weight: 600; color: var(--muted); margin-bottom: 0.4rem; }
  .pprice .per { font-size: 0.875rem; color: var(--muted); margin-bottom: 0.35rem; }
  .pdesc { font-size: 0.875rem; color: var(--muted); margin-bottom: 1.75rem; line-height: 1.55; }
  .pcta { display: block; width: 100%; text-align: center; padding: 0.9rem; border-radius: var(--rsm); font-size: 0.9rem; font-weight: 800; text-decoration: none; cursor: pointer; border: none; transition: all 0.2s; letter-spacing: -0.01em; }
  .cto { background: transparent; color: var(--white); border: 1px solid var(--border-h); }
  .cto:hover { background: rgba(255,255,255,.06); border-color: rgba(255,255,255,.25); }
  .cts { background: var(--green); color: #000; }
  .cts:hover { background: #4ade80; box-shadow: 0 6px 24px rgba(34,197,94,.3); transform: translateY(-1px); }
  .pdiv { height: 1px; background: var(--border); margin: 1.5rem 0; }
  .pfl { list-style: none; display: flex; flex-direction: column; gap: 0.65rem; margin-bottom: 1.75rem; }
  .pf { display: flex; align-items: center; gap: 0.7rem; font-size: 0.875rem; }
  .pf.on { color: var(--white); }
  .pf.off { color: var(--muted2); }
  .fck { color: var(--green); font-size: 0.75rem; flex-shrink: 0; }
  .fdash { color: rgba(255,255,255,.18); font-size: 0.75rem; flex-shrink: 0; }
  .soon { font-size: 0.62rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; background: rgba(234,179,8,.12); color: #facc15; border: 1px solid rgba(234,179,8,.2); padding: 0.15rem 0.5rem; border-radius: 4px; margin-left: 0.25rem; }

  .final { padding: 8rem 1.5rem; text-align: center; position: relative; overflow: hidden; border-top: 1px solid var(--border); }
  .final::before { content: ''; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: 700px; height: 400px; background: radial-gradient(ellipse, var(--green-glow) 0%, transparent 70%); pointer-events: none; }
  .final-in { position: relative; max-width: 680px; margin: 0 auto; }
  .fh2 { font-size: clamp(2.5rem, 6vw, 4.75rem); font-weight: 900; letter-spacing: -0.05em; line-height: 1.04; margin-bottom: 1.25rem; }
  .fh2 .g { color: var(--green); }
  .fp { font-size: 1.1rem; color: var(--muted); line-height: 1.7; margin-bottom: 2.5rem; }
  .fnote { font-size: 0.78rem; color: var(--muted2); margin-top: 1.25rem; }

  footer { border-top: 1px solid var(--border); padding: 1.75rem 2rem; display: flex; align-items: center; justify-content: space-between; }
  .fl { display: flex; align-items: center; gap: 8px; }
  .flt { font-size: 0.9rem; font-weight: 800; color: var(--muted); letter-spacing: -0.02em; }
  .fc2 { font-size: 0.78rem; color: var(--muted2); margin-left: 1rem; }
  .fls { display: flex; gap: 1.5rem; }
  .fls a { font-size: 0.8rem; color: var(--muted2); text-decoration: none; transition: color 0.2s; }
  .fls a:hover { color: var(--white); }

  @keyframes fu { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }

  @media (max-width: 900px) {
    nav { padding: 0 1rem; }
    .nav-mid { display: none; }
    .fg { grid-template-columns: 1fr 1fr; }
    .sgrid { grid-template-columns: repeat(3,1fr); gap: 1.5rem; }
    .sgrid::after { display: none; }
    .pg { grid-template-columns: 1fr; }
    .ps-grid { grid-template-columns: 1fr; }
    .stats-in { grid-template-columns: 1fr; gap: 0; }
    .tg { grid-template-columns: 1fr; }
    .demo-body { grid-template-columns: 1fr; }
    footer { flex-direction: column; gap: 1rem; text-align: center; }
    .fls { flex-wrap: wrap; justify-content: center; }
  }
  @media (max-width: 600px) {
    .fg { grid-template-columns: 1fr; }
    .sgrid { grid-template-columns: 1fr 1fr; }
  }
`;

const LandingPage = ({ onSignup, onSignin }) => {
  return (
    <>
      <style>{styles}</style>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />

      {/* NAV */}
      <nav>
        <a className="nav-logo" href="#">
          <div className="logo-mark">C</div>
          <span className="logo-text">Clarimeet</span>
        </a>
        <div className="nav-mid">
          <a href="#features" className="nav-a">Features</a>
          <a href="#how" className="nav-a">How it works</a>
          <a href="#pricing" className="nav-a">Pricing</a>
        </div>
        <div className="nav-r">
          <button className="btn-si" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-in"}>Sign in</button>
          <button className="btn-nc" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-up"}>Get started free</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-glow"></div>
        <div className="hero-grid"></div>

        <div className="hero-badge">
          <div className="bdot"></div>
          AI-powered meeting intelligence
        </div>

        <h1 className="hero-h1">
          Your meetings are costing<br />you <span className="g">20 hours a week.</span>
        </h1>

        <p className="hero-p">
          Clarimeet turns any meeting into decisions, action items, and next steps — automatically. Paste a transcript, upload a recording, or go live. Done in 10 seconds.
        </p>

        <div className="hero-btns">
          <button className="btn-p" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-up"}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>
            Get started for free
          </button>
          <button className="btn-s" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-in"}>
            Sign in
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          </button>
        </div>

        <div className="hero-trust">
          <div className="avs">
            <div className="av" style={{ background: '#22c55e' }}>AK</div>
            <div className="av" style={{ background: '#3b82f6' }}>MT</div>
            <div className="av" style={{ background: '#a855f7' }}>JS</div>
            <div className="av" style={{ background: '#f97316' }}>RL</div>
          </div>
          <span className="trust-txt">Join early — free to start, no card needed</span>
        </div>

        <div className="demo-wrap">
          <div className="demo-card">
            <div className="demo-bar">
              <div className="demo-dots">
                <div className="dd dd-r"></div>
                <div className="dd dd-y"></div>
                <div className="dd dd-g"></div>
              </div>
              <div className="demo-url">app.clarimeet.com — Q3 Planning Call · 47 min</div>
            </div>
            <div className="demo-body">
              <div>
                <div className="ds" style={{ marginBottom: '1rem' }}>
                  <div className="dl">✦ Decisions made</div>
                  <div className="di"><div className="dp cg"></div>Launch pushed to Oct 14th — confirmed by CEO</div>
                  <div className="di"><div className="dp cg"></div>Design team owns onboarding flow revamp</div>
                  <div className="di"><div className="dp cg"></div>Analytics dashboard cut from v1 scope</div>
                </div>
                <div className="ds">
                  <div className="dl">⚑ Blockers identified</div>
                  <div className="di"><div className="dp cr"></div>API keys not provisioned — Dev team blocked</div>
                  <div className="di"><div className="dp cy"></div>Legal review still pending on T&Cs</div>
                </div>
              </div>
              <div>
                <div className="ds" style={{ marginBottom: '1rem' }}>
                  <div className="dl">✓ Action items</div>
                  <div className="di"><div className="dp cb"></div>Sarah — Update roadmap doc by EOD Friday</div>
                  <div className="di"><div className="dp cb"></div>Dev team — Fix staging env by Thursday</div>
                  <div className="di"><div className="dp cb"></div>Mark — Send client proposal Mon AM</div>
                  <div className="di"><div className="dp cb"></div>James — Sync with legal re: compliance</div>
                </div>
                <div className="ds">
                  <div className="dl">Urgency</div>
                  <div className="upills">
                    <span className="up uh">🔴 2 High</span>
                    <span className="up um">🟡 3 Med</span>
                    <span className="up ul">🟢 1 Low</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LOGOS */}
      <div className="logos">
        <p className="logos-l">Trusted by teams at</p>
        <div className="logos-r">
          <span className="li">Notion</span>
          <span className="li">Linear</span>
          <span className="li">Vercel</span>
          <span className="li">Stripe</span>
          <span className="li">Loom</span>
          <span className="li">Figma</span>
        </div>
      </div>

      {/* PROBLEM / SOLUTION */}
      <div className="sw">
        <div className="stag">The problem</div>
        <h2 className="sh2">You were in the meeting.<br />You still don't know what happened.</h2>
        <p className="sp" style={{ marginBottom: 0 }}>A 30-minute call creates 90 minutes of invisible follow-up work. Clarimeet kills that debt before it accumulates.</p>
        <div className="ps-grid">
          <div className="psc prob">
            <div className="psh">❌ Without Clarimeet</div>
            <div className="psi"><span className="xi">✕</span>45 min writing a recap nobody reads</div>
            <div className="psi"><span className="xi">✕</span>"Who owns that again?" on Slack at 6pm</div>
            <div className="psi"><span className="xi">✕</span>Monday re-hashes Friday's decisions. Again.</div>
            <div className="psi"><span className="xi">✕</span>Client deliverable missed — it was never written down</div>
            <div className="psi"><span className="xi">✕</span>15–20 hours of invisible work every single week</div>
          </div>
          <div className="psc sol">
            <div className="psh">✓ With Clarimeet</div>
            <div className="psi"><span className="ci">✓</span>Full summary ready in 10 seconds flat</div>
            <div className="psi"><span className="ci">✓</span>Every action item has an owner — automatically</div>
            <div className="psi"><span className="ci">✓</span>Decisions timestamped and searchable forever</div>
            <div className="psi"><span className="ci">✓</span>Client commits captured before you hang up</div>
            <div className="psi"><span className="ci">✓</span>One click exports to email or PDF. Done.</div>
          </div>
        </div>
      </div>

      {/* STATS */}
      <div className="stats-bg">
        <div className="stats-in">
          <div className="sb">
            <div className="sn">90<span style={{ fontSize: '2rem' }}>min</span></div>
            <div className="sl">of debt created by a 30-min meeting</div>
          </div>
          <div className="sb">
            <div className="sn">10<span style={{ fontSize: '2rem' }}>sec</span></div>
            <div className="sl">for Clarimeet to process any meeting</div>
          </div>
          <div className="sb">
            <div className="sn">20<span style={{ fontSize: '2rem' }}>hrs</span></div>
            <div className="sl">given back to your team every week</div>
          </div>
        </div>
      </div>

      {/* FEATURES */}
      <div className="fbg" id="features">
        <div className="sw">
          <div className="stag">Features</div>
          <h2 className="sh2">Everything a great recap<br />should include. Automated.</h2>
          <p className="sp">No more copy-pasting. No more "did we decide?" Clarimeet extracts every signal from your meeting — instantly.</p>
          <div className="fg">
            <div className="fc">
              <div className="fi">📋</div>
              <div className="ft">One-paragraph summary</div>
              <p className="fd">The entire meeting distilled into one clear paragraph. Read it in 15 seconds, understand everything that mattered.</p>
            </div>
            <div className="fc">
              <div className="fi">⚡</div>
              <div className="ft">Decisions, extracted</div>
              <p className="fd">Every decision flagged and timestamped. No more "I thought we agreed on this" conversations by Friday.</p>
            </div>
            <div className="fc">
              <div className="fi">✅</div>
              <div className="ft">Action items with owners</div>
              <p className="fd">Tasks assigned directly from the conversation. Everyone knows exactly what they own — no nagging required.</p>
            </div>
            <div className="fc">
              <div className="fi">🚧</div>
              <div className="ft">Blocker detection</div>
              <p className="fd">What's blocking your team is surfaced automatically. Fix it fast instead of discovering it at the worst moment.</p>
            </div>
            <div className="fc">
              <div className="fi">🔴</div>
              <div className="ft">Urgency tags</div>
              <p className="fd">Red, yellow, green — prioritized automatically. Your team always knows what to do first, no micromanagement needed.</p>
            </div>
            <div className="fc">
              <div className="fi">📤</div>
              <div className="ft">One-click export</div>
              <p className="fd">Email your team or download a PDF before you close the call. Zero friction, complete clarity, every time.</p>
            </div>
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div className="sw" id="how">
        <div className="stag">How it works</div>
        <h2 className="sh2">From meeting to action.<br />Five steps, ten seconds.</h2>
        <div className="sgrid">
          <div className="step">
            <div className="snum">1</div>
            <div className="stitle">End the call</div>
            <p className="sdesc">No bots join your calls. No awkward calendar links. Just your normal meeting.</p>
          </div>
          <div className="step">
            <div className="snum">2</div>
            <div className="stitle">Import or paste</div>
            <p className="sdesc">Paste transcript, upload recording, or hit live record during the call.</p>
          </div>
          <div className="step">
            <div className="snum">3</div>
            <div className="stitle">AI processes</div>
            <p className="sdesc">10 seconds. Clarimeet reads, extracts, and structures everything that mattered.</p>
          </div>
          <div className="step">
            <div className="snum">4</div>
            <div className="stitle">Review output</div>
            <p className="sdesc">Summary → decisions → blockers → actions → urgency. Crystal clear.</p>
          </div>
          <div className="step">
            <div className="snum">5</div>
            <div className="stitle">Share & move on</div>
            <p className="sdesc">Email team or download PDF. Meeting debt: zero.</p>
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="fbg">
        <div className="sw">
          <div className="stag">Testimonials</div>
          <h2 className="sh2">Teams shipping faster.<br />Leaders sleeping better.</h2>
          <div className="tg">
            <div className="tc">
              <div className="tstars">★★★★★</div>
              <p className="ttxt">"We had 12 meetings a week and no one knew who owned what. Clarimeet fixed that on day one. Monday stand-ups went from 40 minutes to 12."</p>
              <div className="tau">
                <div className="tav" style={{ background: '#22c55e' }}>AK</div>
                <div>
                  <div className="tnm">Alex Kim</div>
                  <div className="trl">Founder, Stackwise</div>
                </div>
              </div>
            </div>
            <div className="tc">
              <div className="tstars">★★★★★</div>
              <p className="ttxt">"Client relationships improved overnight. I send a Clarimeet summary before I close my laptop. Clients think I have a photographic memory."</p>
              <div className="tau">
                <div className="tav" style={{ background: '#3b82f6' }}>MT</div>
                <div>
                  <div className="tnm">Maya Tran</div>
                  <div className="trl">Agency Owner, Tran Creative</div>
                </div>
              </div>
            </div>
            <div className="tc">
              <div className="tstars">★★★★★</div>
              <p className="ttxt">"I was spending 3 hours a day on meeting follow-ups. Now it's 10 minutes. The first tool in years that actually gave me real time back."</p>
              <div className="tau">
                <div className="tav" style={{ background: '#a855f7' }}>JS</div>
                <div>
                  <div className="tnm">Jamie Santos</div>
                  <div className="trl">Head of Product, Finflow</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PRICING */}
      <div className="sw" id="pricing">
        <div style={{ textAlign: 'center' }}>
          <div className="stag" style={{ justifyContent: 'center' }}>Pricing</div>
          <h2 className="sh2">Start free. Scale when ready.</h2>
          <p className="sp" style={{ margin: '0 auto' }}>No credit card required. No meeting bots. No drama.</p>
        </div>
        <div className="pg">
          {/* FREE */}
          <div className="pc">
            <div className="pname">Free</div>
            <div className="pprice">
              <span className="dol">$</span>
              <span className="amt">0</span>
              <span className="per">/ month</span>
            </div>
            <p className="pdesc">3 meetings per month. Enough to see exactly what you've been missing all along.</p>
            <button className="pcta cto" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-up"}>Get started for free</button>
            <div className="pdiv"></div>
            <ul className="pfl">
              <li className="pf on"><span className="fck">✓</span> 3 meetings per month</li>
              <li className="pf on"><span className="fck">✓</span> AI summary & decisions</li>
              <li className="pf on"><span className="fck">✓</span> Action items with owners</li>
              <li className="pf on"><span className="fck">✓</span> Urgency tags (🔴🟡🟢)</li>
              <li className="pf on"><span className="fck">✓</span> Blockers & open questions</li>
              <li className="pf on"><span className="fck">✓</span> Paste transcript</li>
              <li className="pf on"><span className="fck">✓</span> PDF export</li>
              <li className="pf off"><span className="fdash">—</span> Email team export</li>
              <li className="pf off"><span className="fdash">—</span> Zoom import <span className="soon">soon</span></li>
              <li className="pf off"><span className="fdash">—</span> Google Meet <span className="soon">soon</span></li>
              <li className="pf off"><span className="fdash">—</span> Teams import <span className="soon">soon</span></li>
            </ul>
          </div>
          {/* PRO */}
          <div className="pc pop">
            <div className="ptag">Most popular</div>
            <div className="pname" style={{ color: 'var(--green)' }}>Pro</div>
            <div className="pprice">
              <span className="dol">$</span>
              <span className="amt">19</span>
              <span className="per">/ month</span>
            </div>
            <p className="pdesc">Unlimited meetings. Every export included. Zero meeting debt, every single week.</p>
            <button className="pcta cts" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-up"}>Start with Pro →</button>
            <div className="pdiv" style={{ background: 'rgba(34,197,94,.15)' }}></div>
            <ul className="pfl">
              <li className="pf on"><span className="fck">✓</span> Unlimited meetings</li>
              <li className="pf on"><span className="fck">✓</span> AI summary & decisions</li>
              <li className="pf on"><span className="fck">✓</span> Action items with owners</li>
              <li className="pf on"><span className="fck">✓</span> Urgency tags (🔴🟡🟢)</li>
              <li className="pf on"><span className="fck">✓</span> Blockers & open questions</li>
              <li className="pf on"><span className="fck">✓</span> Paste transcript</li>
              <li className="pf on"><span className="fck">✓</span> PDF export</li>
              <li className="pf off"><span className="fdash">—</span> Email team export <span className="soon">soon</span></li>
              <li className="pf off"><span className="fdash">—</span> Zoom import <span className="soon">soon</span></li>
              <li className="pf off"><span className="fdash">—</span> Google Meet <span className="soon">soon</span></li>
              <li className="pf off"><span className="fdash">—</span> Teams import <span className="soon">soon</span></li>
            </ul>
          </div>
        </div>
      </div>

      {/* FINAL CTA */}
      <section className="final">
        <div className="final-in">
          <h2 className="fh2">Your Sunday nights<br />will <span className="g">thank you.</span></h2>
          <p className="fp">Stop letting meetings create invisible debt. Clarimeet turns every call into clarity, action, and momentum — in 10 seconds.</p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn-p" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-up"} style={{ fontSize: '1rem', padding: '0.9rem 2.5rem' }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" /></svg>
              Get started for free
            </button>
            <button className="btn-s" onClick={() => window.location.href = "https://accounts.clarimeet.com/sign-in"} style={{ fontSize: '1rem', padding: '0.9rem 2rem' }}>
              Sign in
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </button>
          </div>
          <p className="fnote">No credit card required · 3 free meetings · Cancel anytime</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="fl">
          <div className="logo-mark" style={{ width: '24px', height: '24px', fontSize: '12px' }}>C</div>
          <span className="flt">Clarimeet</span>
          <span className="fc2">© 2025 Clarimeet. All rights reserved.</span>
        </div>
        <div className="fls">
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/support">Support</a>
          <a href="/about">About</a>
        </div>
      </footer>
    </>
  );
};

export default LandingPage;
